
import Vue from 'vue'
import App from './App'
import router from './router'
//引入公用样式
import '../src/assets/css/common.css'
//动画文件
import animated from 'animate.css'
import $ from 'jquery'

Vue.config.productionTip = false;

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
Vue.use(animated)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js